// Import Libraries
import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
// Import JS Modules
import uniqueId from 'lodash.uniqueid';

export default function SelectWrapper({
  value: propsValue,
  options,
  placeholder,
  label = '',
  id,
  disabled,
  isRequired,
  className,
  name,
  onFocus,
  defaultText,
  inputStyleLink,
  withCaret,
  onChange,
}) {
  useEffect(() => {
    if (!propsValue) {
      [...selectRef.current].forEach(option => (option.selected = false));
    }
  }, [propsValue]);

  const [valueHasBeenChanged, setValueHasBeenChanged] = useState(false);
  const selectRef = useRef();
  let selectValue = propsValue;

  const $options = options.map((option, i) => {
    if (selectValue == option.label) {
      selectValue = option.value;
    }

    const selectedOption = selectValue == option.value;

    if (typeof option.label === 'string' && typeof option.value === 'string' && option.value.includes("print_border--yes")) {
      let parenthesisPos = option.label.indexOf("(")
      if (parenthesisPos >= 0) {
        option.label = option.label.slice(0, parenthesisPos-1) + " with border " + option.label.slice(parenthesisPos)
      } else {
        option.label = option.label + " with border";
      }
    }

    return (
      <option
        key={i}
        className={classNames({ checked: selectedOption })}
        value={'' + option.value}
        disabled={!!option.disabled}>
        {option.label}
      </option>
    );
  });

  if (placeholder) {
    if (!valueHasBeenChanged) {
      selectValue = '';
    }

    $options.unshift(
      <option key="placeholder" disabled value="">
        {placeholder}
      </option>
    );
  }

  function handleChange(e) {
    onChange && onChange(e.target.value);

    setValueHasBeenChanged(true);
  }

  function handleLabelClick() {
    selectRef.current.focus();
  }

  const inputID =
    id ||
    `${label || uniqueId('select')}-input-id`.toLowerCase().replace(' ', '-');

  const $select = (
    <select
      aria-label={label || undefined}
      className={classNames('custom-select', className)}
      disabled={!!disabled}
      id={inputID}
      aria-required={isRequired}
      name={name || inputID}
      ref={selectRef}
      value={selectValue}
      onChange={handleChange}
      onFocus={onFocus}>
      {$options}
    </select>
  );

  if (inputStyleLink) {
    const { label: valueText = defaultText } =
      options.find(option => option.value == selectValue) || {};

    return (
      <div
        className={classNames('custom-select__wrapper', {
          dropdown: withCaret,
        })}>
        {label && (
          <label htmlFor={inputID} onClick={handleLabelClick}>
            {label}
            {valueText && ':'}
          </label>
        )}
        <div className="custom-select__value dropdown-toggle">
          {(valueText || '').replace(/\(.*\)\s*/, '')}
          {$select}
        </div>
      </div>
    );
  }

  return $select;
}
